/**
 * Convert locale
 * Converts "no" to "nb"
 */
function getDayJSLocale(locale) {
  if (locale === "no") return "nb";
  return locale;
}

module.exports = {
  getDayJSLocale,
};
